module.exports = "<em *ngIf=\"isChecked\" (click)=\"unselect()\" class=\"fa fa-check-square-o checkbox-icon\" [ngClass]=\"{ 'checkbox-disabled': checkboxDisabled }\"></em>\n<em *ngIf=\"!isChecked\" (click)=\"select()\" class=\"fa fa-square-o checkbox-icon\" [ngClass]=\"{ 'checkbox-disabled': checkboxDisabled }\"></em>\n\n<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/checkbox/checkbox.component.html
// module id = ../../../../../src/app/shared/components/checkbox/checkbox.component.html
// module chunks = main